import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Asset, AssetsService } from 'src/app/shared/services/assets.service';

@Component({
  selector: 'app-asset-list',
  templateUrl: './asset-list.component.html',
  styleUrls: ['./asset-list.component.scss']
})
export class AssetListComponent implements OnInit {
  loading: boolean = false;
  assets: Asset[] = new Array<Asset>();
  exploratoryAssets: Asset[] = new Array<Asset>();
  
  constructor(private router: Router, private assetSvc: AssetsService) { }

  ngOnInit(): void {
    this.loading = true;
    this.assetSvc.getAssets()
      .subscribe(resp => {
        var aList = new Array<Asset>();
        var eList = new Array<Asset>();
        resp.forEach((x, i) => {
          if(x.IsExploratory == true) {
            eList.push(x);
          } else {
            aList.push(x);
          }
        });
        this.assets = aList;
        this.exploratoryAssets = eList;
        this.loading = false;
      });
  }
  
}
